var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"broad-layout menu_wkBox_back_box"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.url),expression:"url"}],staticClass:"img-bg"})])}
var staticRenderFns = []

export { render, staticRenderFns }